import { createContext, useContext, useState } from 'react'

interface MobileHeaderConfig {
  title?: string
  showBack?: boolean
}

interface MobileHeaderContextValue {
  config: MobileHeaderConfig
  setConfig: (config: MobileHeaderConfig) => void
}

const MobileHeaderContext = createContext<MobileHeaderContextValue>({
  config: {},
  setConfig: () => {},
})

export function MobileHeaderProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = useState<MobileHeaderConfig>({})
  return (
    <MobileHeaderContext.Provider value={{ config, setConfig }}>
      {children}
    </MobileHeaderContext.Provider>
  )
}

export function useMobileHeader() {
  return useContext(MobileHeaderContext)
}
